/**
 * React-Query hook that fetches the full Stage 9 coaching context once
 * per page. The context is the single upstream data source for cards
 * and (through the explanation hook) for message-key rendering.
 */
import { useQuery } from "@tanstack/react-query";

import { getCoachingContext } from "@/api/coachingApi";

export const coachingContextQueryKey = (params = {}) =>
  ["coaching-context", params.effective_date || "today"];

export const useCoachingContext = ({ effectiveDate } = {}) => {
  const params = effectiveDate ? { effective_date: effectiveDate } : {};
  return useQuery({
    queryKey: coachingContextQueryKey(params),
    queryFn: ({ signal }) => getCoachingContext(params, { signal }),
    staleTime: 60_000,
    retry: (failureCount, error) => {
      if (error?.status === 401 || error?.status === 403) return false;
      return failureCount < 1;
    },
  });
};
